import { ToastContextType } from "../../types/toastTypes";

export const validateFile = (
  file: File,
  addToast: ToastContextType["addToast"]
): boolean => {
  if (file.size > 26214400) {
    addToast("File size must be under 2.5MB.", "error");
    return false;
  }

  if (!file.name.match(/\.(xlsx|csv)$/)) {
    addToast("Only .xlsx or .csv files are allowed.", "error");
    return false;
  }

  return true;
};
